var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogle = function SvgGoogle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M22.501 12.233c0-.863-.071-1.493-.226-2.146h-10.06v3.896h5.905c-.119.969-.762 2.427-2.19 3.407l-.02.13 3.18 2.415.22.022c2.024-1.832 3.191-4.527 3.191-7.724"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.215 22.5c2.893 0 5.321-.933 7.095-2.543l-3.381-2.567c-.905.618-2.12 1.05-3.714 1.05a6.44 6.44 0 0 1-6.096-4.363l-.125.01-3.307 2.509-.044.117c1.762 3.43 5.381 5.787 9.572 5.787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.12 14.077A6.4 6.4 0 0 1 5.763 12c0-.723.131-1.423.345-2.077l-.006-.139-3.348-2.548-.11.05A10.34 10.34 0 0 0 1.501 12c0 1.692.417 3.29 1.143 4.713z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M12.215 5.56c2.012 0 3.369.852 4.143 1.563L19.38 4.23c-1.857-1.692-4.273-2.73-7.166-2.73-4.19 0-7.81 2.357-9.572 5.787l3.465 2.636a6.465 6.465 0 0 1 6.107-4.363"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export default ForwardRef;